module.exports = __webpack_public_path__ + "img/R7.4b7d0858.png";